import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Programs', path: '/programs' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full z-50 backdrop-blur-md bg-white/90 border-b border-slate-100/50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="navbar-logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_canada-pathway-3/artifacts/wzgtavxp_IMG_0276-removebg-preview.png"
              alt="ELARA Education"
              className="h-12 w-auto"
              data-testid="navbar-logo"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`text-sm font-medium uppercase tracking-wider transition-colors ${
                  isActive(link.path)
                    ? 'text-secondary'
                    : 'text-slate-800 hover:text-secondary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/login"
              data-testid="nav-staff-portal"
              className="px-6 py-2.5 bg-gradient-to-r from-primary via-primary-light to-primary text-white font-playfair text-base font-semibold tracking-wide hover:from-primary-light hover:via-primary hover:to-primary-light transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Elara Portal
            </Link>
            <Link
              to="/contact"
              data-testid="nav-cta-button"
              className="px-6 py-3 bg-secondary text-primary font-semibold tracking-wide hover:bg-secondary-light transition-all duration-300"
            >
              Book Consultation
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-slate-800"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden py-4 border-t border-slate-100"
            data-testid="mobile-menu"
          >
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                className={`block py-3 text-sm font-medium uppercase tracking-wider ${
                  isActive(link.path)
                    ? 'text-secondary'
                    : 'text-slate-800 hover:text-secondary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/login"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-staff-portal"
              className="block mt-4 px-6 py-3 bg-gradient-to-r from-primary via-primary-light to-primary text-white text-center font-playfair text-lg font-semibold tracking-wide shadow-lg"
            >
              Elara Portal
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-cta-button"
              className="block mt-4 px-6 py-3 bg-secondary text-primary text-center font-semibold tracking-wide hover:bg-secondary-light transition-all duration-300"
            >
              Book Consultation
            </Link>
          </motion.div>
        )}
      </div>
    </nav>
  );
};